import React from 'react';
import './styles.scss';

const RightArrow = () => {
  return (
    <svg
      className="right-arrow"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 11"
    >
      <path
        d="M0.344002 6.1681V4.6321H9.656L8.312 3.3041L6.664 1.6721L7.752 0.600098L12.552 5.4001L7.752 10.2001L6.664 9.1281L8.312 7.4961C8.776 7.0481 9.208 6.6161 9.656 6.1681H0.344002Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RightArrow;
